import React, { useEffect, useState } from "react";
import { API_BASE_URL, API_KEY } from "../../../config.js";
import { useTranslation } from "react-i18next";
import "./BookingForm.css";
import { useNavigate } from "react-router-dom";
// Modal component
const BookingForm = ({
  showModal,
  onClose,
  userInfo,
  houseId,
  setShowPendingModal,
}) => {
  // Controls PendingModal visibility
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [checkIn, setCheckInDate] = useState("");
  const [checkOut, setCheckOutDate] = useState("");
  const [type_proof_of_identity, setIdType] = useState("Kebele ID");
  const [phoneError, setPhoneError] = useState("");

  const [showCitizenshipModal, setShowCitizenshipModal] = useState(false);
  const [slideUp, setSlideUp] = useState(false);

  const today = new Date().toISOString().split("T")[0];

  const { t } = useTranslation();

  const navigate = useNavigate();

  const validatePhoneNumber = (phone) => {
    const regex = /^[79]\d{8}$/;
    return regex.test(phone);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!userInfo?.username) {
      window.Telegram.WebApp.showAlert(
        t("Telegram Username not found. Please set telegram username")
      );
      //alert("Telegram Username not found. Please set telegram username");
      return;
    }

    if (!validatePhoneNumber(phoneNumber)) {
      setPhoneError(
        t(
          "Invalid phone number. It must start with 7 or 9 and be exactly 9 digits."
        )
      );
      return;
    }

    setPhoneError("");
    setShowPendingModal(true);

    const formattedPhoneNumber = `+251${phoneNumber}`;

    const formData = {
      house: houseId,
      username: userInfo?.username,
      checkIn,
      checkOut,
      phoneNumber: formattedPhoneNumber,
      type_proof_of_identity,
      chatId: userInfo?.id,
      first_name: firstName,
      last_name: lastName,
    };

    console.log(formData);

    try {
      const initData = window.Telegram.WebApp.initData;
      const response = await fetch(
        `${API_BASE_URL}/user/api/v1/reservation/save/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": API_KEY,
            "X-Telegram-InitData": initData,
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setShowPendingModal(true);
        onClose();
      } else {
        setShowPendingModal(false);
        window.Telegram.WebApp.showAlert(
          "Failed: Room reserved by another guest."
        );
        //alert("Failed: Room reserved by another guest.");
      }
    } catch (error) {
      setShowPendingModal(false);
      window.Telegram.WebApp.showAlert("An error occurred. Please try again.");
      //alert("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    if (showCitizenshipModal) {
      setTimeout(() => setSlideUp(true), 10);
    } else {
      setSlideUp(false);
    }
  }, [showCitizenshipModal]);

  const handleClick = () => {
    navigate("/payment");
  };

  if (!showModal) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center"
        style={{ zIndex: "10" }}
      >
        <div
          className="bg-white p-6 rounded-lg max-w-md w-full h-full"
          style={{
            maxHeight: "100vh",
            overflowY: "auto", // Enable vertical scrolling
            overflowX: "auto",
          }}
        >
          <h4 className="text-md font-semibold text-black mb-4">
            {t("Booking Detail")}
          </h4>
          <p className="text-xs text-black">
            {t("Fill out the information below and confirm your booking")}.
          </p>
          <br />
          <form onSubmit={handleFormSubmit} className="text-base">
            <div className="mb-4">
              <label className="block text-sm font-bold mb-2 text-black">
                {t("First Name")} <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="Enter your first name"
                className="w-full px-3 py-2 border rounded-lg bg-gray-100 text-black text-base placeholder:text-base"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-bold mb-2 text-black">
                {t("Last Name")} <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Enter your last name"
                className="w-full px-3 py-2 border rounded-lg bg-gray-100 text-black text-base placeholder:text-base"
                required
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-bold mb-2 text-black">
                {t("Phone number")} <span className="text-red-500">*</span>
              </label>
              <div className="flex space-x-2">
                <input
                  type="text"
                  className="w-16 px-3 py-2 border rounded-lg bg-gray-100 text-black text-base placeholder:text-base"
                  placeholder="+251"
                  disabled
                />
                <input
                  type="number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Contact number"
                  className={`flex-1 px-3 py-6 border rounded-lg bg-gray-100 text-black text-base placeholder:text-base ${
                    phoneError ? "border-red-500" : ""
                  }`}
                  required
                />
              </div>
              {phoneError && (
                <p className="text-red-500 text-sm mt-2">{phoneError}</p>
              )}
            </div>

            <div className="flex space-x-2">
              <div className="mb-4">
                <label className="block text-sm font-bold mb-2 text-black">
                  {t("Check-in")} <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  value={checkIn}
                  onChange={(e) => setCheckInDate(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg bg-gray-100 text-black"
                  min={today} // Disable past dates
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-bold mb-2 text-black">
                  {t("Check-out")} <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  value={checkOut}
                  onChange={(e) => setCheckOutDate(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg bg-gray-100 text-black"
                  min={checkIn || today}
                  required
                />
              </div>
            </div>

            <div className="flex space-x-2">
              <div className="mb-4 w-full">
                <label className="block text-sm font-bold mb-2 text-black">
                  {t("Select ID type you have")}
                  <span className="text-red-500">*</span>
                </label>
                <div className="radio-group custom-grid">
                  {[
                    "National ID",
                    "Kebele ID",
                    "Driving License",
                    "Passport",
                  ].map((type) => (
                    <div
                      key={type}
                      className={`radio-option ${
                        type_proof_of_identity === type ? "active" : ""
                      }`}
                      onClick={() => {
                        setIdType(type);
                        if (type === "Passport") {
                          setShowCitizenshipModal(true);
                        }
                      }}
                    >
                      <input
                        type="radio"
                        id={type}
                        name="type_proof_of_identity"
                        value={type}
                        checked={type_proof_of_identity === type}
                        onChange={() => setIdType(type)}
                        className="hidden"
                      />
                      <label htmlFor={type}>{type}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <br />
            <hr />
            <br />
            <div className="flex space-x-8">
              <button
                onClick={onClose}
                className="bg-white-500 border border-black text-black rounded-md text-sm px-10 py-3"
              >
                {t("Cancel")}
              </button>
              <button
                type="submit"
                className="bg-blue-500 text-white rounded-lg text-sm px-5 py-3"
                style={{ backgroundColor: "#6938ef" }}
              >
                {t("Confirm Booking")}
              </button>
            </div>
          </form>
        </div>
      </div>

      {showCitizenshipModal && (
        <div
          className="citizenship-modal-container"
          onClick={() => setShowCitizenshipModal(false)}
        >
          <div
            className={`bg-white p-6 rounded-t-lg max-w-md w-full shadow-xl transform transition-transform duration-300 ease-out max-h-[90vh] overflow-y-auto ${
              slideUp ? "translate-y-0" : "translate-y-full"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-lg font-bold text-black mb-4">
              Are you Ethiopian citizen?
            </h2>
            <p className="text-sm text-black mb-6">
              Please select the following options
            </p>
            <div className="flex justify-between">
              <button
                onClick={() => {
                  setShowCitizenshipModal(false);
                  handleClick()
                }}
                className="w-[48%] border border-gray-400 text-black py-3 rounded-lg"
              >
                No
              </button>
              <button
                onClick={() => setShowCitizenshipModal(false)}
                className="w-[48%] bg-[#6938ef] text-white py-3 rounded-lg"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BookingForm;
